import { render, staticRenderFns } from "./DetailedReport.vue?vue&type=template&id=a73ed712&scoped=true"
import script from "./DetailedReport.vue?vue&type=script&lang=js"
export * from "./DetailedReport.vue?vue&type=script&lang=js"
import style0 from "./DetailedReport.vue?vue&type=style&index=0&id=a73ed712&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73ed712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a73ed712')) {
      api.createRecord('a73ed712', component.options)
    } else {
      api.reload('a73ed712', component.options)
    }
    module.hot.accept("./DetailedReport.vue?vue&type=template&id=a73ed712&scoped=true", function () {
      api.rerender('a73ed712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/ArchivesView/components/DetailedReport.vue"
export default component.exports